import { render, staticRenderFns } from "./top-home.vue?vue&type=template&id=0f3f59e4&scoped=true"
import script from "./top-home.vue?vue&type=script&lang=js"
export * from "./top-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3f59e4",
  null
  
)

export default component.exports